import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {AUTHORIZATION_HEADER, BEARER} from './model/constants';
import {Router} from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (navigator.onLine === false) {
      this.router.navigate(['/shared/offline']);
    }

    request = request.clone({
      withCredentials: true
    });

    const bearerToken = window.localStorage.getItem(BEARER);
    if (bearerToken) {
      request = request.clone({
        setHeaders: { [AUTHORIZATION_HEADER] : BEARER + ' ' + bearerToken }
      });
    }

    return next.handle(request)
      .pipe(catchError(err => {
        // On Unauthorized or Forbidden status we force the logout of the User (except for VIP)
        if (!bearerToken) {
          if (err.status === 401) {
            this.router.navigate(['/shared/unauthorized']);
          } else if (err.status === 403) {
            this.router.navigate(['/shared/forbidden']);
          }
        }
        return throwError(err);
      }));
  }
}
